export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const usernameRegex = /^[a-zA-Z0-9_]{3,20}$/;

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
